import { Route, Routes } from "react-router";
import styled from "styled-components";
import media from "styled-media-query";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../redux";
import { bindActionCreators } from "redux";

import Detail from "../views/advice/Detail";
import Checkout from "../views/advice/Checkout";

import Loading from "../components/modal/Loading";
import { Feedback } from "@adoptaunabuelo/react-components";
import { useEffect, useState } from "react";
import { Advice, AdviceScheme } from "client-v2";

const FeedbackStyled = styled(Feedback)`
	right: 24px !important;
	left: unset !important;
	${media.lessThan("small")`
        top: 64px;
        left: 24px !important;
        bottom: unset !important;
	`}
`;

const TigerLayout = (props: TigerLayoutProps) => {
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const error = useSelector((state: State) => state.modals.error);

	const [loading, setLoading] = useState(false);
    const [advice, setAdvice] = useState<AdviceScheme | undefined>(undefined);

	useEffect(() => {
		setLoading(true);
		const params = new URLSearchParams(window.location.search);
		const adviceId = params.get("id");
		if (adviceId) {
			Advice.getById(adviceId)
				.then((result) => {
					setAdvice(result.data);
					setLoading(false);
				})
				.catch(() => {
					setShowError({
						show: true,
						message: "La URL no es correcta",
					});
				});
		} else {
			setShowError({
				show: true,
				message: "La URL no es correcta",
			});
		}
	}, []);

	return (
		<>
			<FeedbackStyled
				isVisible={error.show}
				type="error"
				text={error.message}
				onClose={() => setShowError({ show: false })}
			/>

			{loading || !advice ? (
				<Loading isVisible={loading ? true : false} />
			) : (
				<Routes>
					<Route path="/" element={<Detail advice={advice} />} />
					<Route path="/registro" element={<Checkout />} />
				</Routes>
			)}
		</>
	);
};

export default TigerLayout;
export interface TigerLayoutProps {}
